import React, { useState, useEffect } from 'react';
import withOptimizely from '../utils/withOptimizely';
import { useDecision, OptimizelyDecideOption } from '@optimizely/react-sdk';
import { shape, object, string, func, oneOfType, arrayOf, bool } from 'prop-types';

const propTypes = {
    optimizely: shape({
        initialConfig: shape({
            datafile: object,
        }),
    }),
    feature: oneOfType([string, arrayOf(string)]),
    children: func.isRequired,
    disableDecisionEvent: bool,
    shouldWaitForGa: bool,
    isGaPresent: bool,
};

export const Feature = (props) => {
    const { optimizely, feature, children, disableDecisionEvent } = props;

    if (!optimizely?.initialConfig?.datafile) return <>{children({ ...props })}</>;

    // To allow feature segmentation (for example separate feature for mobile and web)
    const featureArray = Array.isArray(feature) ? feature : [feature];
    const decision = getDecision(featureArray, disableDecisionEvent);

    return <>{children({ ...props, ...decision })}</>;
};

const GAFeature = ({ disableDecisionEvent, ...rest }) => {
    const [isGaPresent, setIsGaPresent] = useState(undefined);

    useEffect(() => {
        document.addEventListener('readystatechange', () => {
            if (document.readyState === 'complete') {
                setIsGaPresent(typeof window.ga === 'function' && window.GoogleAnalyticsObject === 'ga' && window.ga.loaded);
            }
        });
    }, []);

    return <Feature {...rest} disableDecisionEvent={disableDecisionEvent || !isGaPresent} />;
};

Feature.propTypes = propTypes;
GAFeature.propTypes = propTypes;
export default withOptimizely(Feature);
export const OptimizelyGAFeature = withOptimizely(GAFeature);

const getDecision = ([firstFeature, ...rest] = [], disableDecisionEvent) => {
    const [{ enabled, variationKey, variables }] = useDecision(firstFeature, {
        autoUpdate: true,
        decideOptions: [disableDecisionEvent && OptimizelyDecideOption.DISABLE_DECISION_EVENT],
    });
    let featureToUse = { isEnabled: enabled, variationKey, variables, feature: firstFeature };

    // If multiple features are enabled, picks the last one
    if (rest.length > 0) {
        for (const feature of rest) {
            const [{ enabled, variationKey, variables }] = useDecision(feature, {
                autoUpdate: true,
                decideOptions: [disableDecisionEvent && OptimizelyDecideOption.DISABLE_DECISION_EVENT],
            });
            if (enabled) featureToUse = { isEnabled: enabled, variationKey, variables, feature };
        }
    }
    return featureToUse;
};
